const Checkbox = ({ 
  id,
  checked, 
  onChange, 
  label,
  disabled = false,
  className = ''
}) => {
  return (
    <div className={`flex items-center gap-spacing-2 ${className}`}>
      <input
        type="checkbox"
        id={id}
        checked={checked}
        onChange={onChange}
        disabled={disabled}
        className="
          appearance-none w-5 h-5 rounded border border-border-default bg-bg-input cursor-pointer
          transition-all flex-shrink-0
          checked:bg-accent checked:border-accent
          hover:border-accent
          focus:outline-none focus:border-accent
          disabled:cursor-not-allowed disabled:opacity-50
          flex items-center justify-center
          checked:after:content-['✓']
          checked:after:text-tertiary
          checked:after:text-[14px]
          checked:after:font-bold
        "
      />
      {label && (
        <label 
          htmlFor={id} 
          className="text-[14px] text-primary cursor-pointer truncate"
        >
          {label}
        </label>
      )}
    </div>
  );
};

export default Checkbox;
